/* Country / language recommendation card.
   Reads Shopify's geolocation suggestion endpoint, compares against the market the
   visitor is currently browsing, and offers a one-click switch via the standard
   /localization form. Dismissal is remembered so it never nags. */
(function(){
var D=window.LUMA_GEO; if(!D) return;
var KEY='luma_geo_v1';
try{ if(localStorage.getItem(KEY)) return; }catch(e){}

/* Which of our published languages best fits a country. Anything not listed
   stays on English — we would rather show English than a half-matched locale. */
var MAP={DE:'de',AT:'de',CH:'de',LI:'de',
         FR:'fr',BE:'fr',LU:'fr',MC:'fr',
         NL:'nl',
         ES:'es',MX:'es',AR:'es',CL:'es',CO:'es',PE:'es',UY:'es',
         PL:'pl'};

function has(list,code){ for(var i=0;i<list.length;i++){ if(list[i].code===code) return list[i]; } return null; }

function show(country,lang,switchLang){
  if(document.getElementById('lumageo')) return;
  var css=document.createElement('style');
  css.textContent=
  '#lumageo{position:fixed;left:20px;bottom:20px;z-index:99998;max-width:330px;background:#fff;'+
  'border:1px solid #e3e0db;box-shadow:0 16px 40px rgba(0,0,0,.14);padding:20px 20px 18px;'+
  'font-family:Inter,-apple-system,"Segoe UI",Arial,sans-serif;color:#101010}'+
  '#lumageo p{margin:0 0 15px;font-size:13.5px;line-height:1.5}'+
  '#lumageo .lgrow{display:flex;gap:8px}'+
  '#lumageo button{font:inherit;font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;'+
  'padding:11px 14px;cursor:pointer;border:1px solid #101010;flex:1}'+
  '#lumageo .lgyes{background:#101010;color:#fff}'+
  '#lumageo .lgno{background:#fff;color:#101010;border-color:#d9d5cf}'+
  '@media(max-width:600px){#lumageo{left:12px;right:12px;bottom:12px;max-width:none}}';
  document.head.appendChild(css);

  var box=document.createElement('div'); box.id='lumageo';
  var tpl=switchLang ? D.line : D.line_currency;
  var txt=tpl.replace('{country}',country.name)
             .replace('{currency}',country.currency||'')
             .replace('{language}',lang?lang.name:'');
  var p=document.createElement('p'); p.textContent=txt;
  var row=document.createElement('div'); row.className='lgrow';
  var yes=document.createElement('button'); yes.className='lgyes'; yes.type='button'; yes.textContent=D.accept;
  var no=document.createElement('button'); no.className='lgno'; no.type='button'; no.textContent=D.stay;
  row.appendChild(yes); row.appendChild(no);
  box.appendChild(p); box.appendChild(row);
  document.body.appendChild(box);

  function done(){ try{ localStorage.setItem(KEY,'1'); }catch(e){} }
  no.addEventListener('click',function(){ done(); box.remove(); });
  yes.addEventListener('click',function(){
    done();
    var f=document.getElementById('lumaGeoForm'); if(!f) return;
    f.querySelector('[name=country_code]').value=country.code;
    f.querySelector('[name=language_code]').value=(switchLang&&lang)?lang.code:D.current_locale;
    f.querySelector('[name=return_to]').value=window.location.pathname+window.location.search;
    f.submit();
  });
}

function run(){
  var qs=new URLSearchParams({source:'geolocation_recommendation'});
  qs.append('country[enabled]','true');
  qs.append('language[enabled]','true');
  fetch('/browsing_context_suggestions.json?'+qs.toString(),{headers:{Accept:'application/json'}})
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(j){
      if(!j||!j.detected_values||!j.detected_values.country) return;
      var code=j.detected_values.country.handle;
      var want=MAP[code]||'en';
      var sameCountry=(code===D.current_country);
      var sameLang=(want===D.current_locale);
      if(sameCountry && sameLang) return;              /* already correct */
      var country=has(D.countries,code); if(!country) return;  /* we do not ship there */
      var lang=has(D.languages,want);
      var switchLang=!sameLang && !!lang;
      if(sameCountry && !switchLang) return;           /* nothing worth offering */
      show(country,lang,switchLang);
    })
    .catch(function(){});
}
document.addEventListener('DOMContentLoaded',function(){ setTimeout(run,900); });
})();